















import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class DadosAno extends Vue {

    get loadingAnos () {
        return this.$store.state.loading_anos;
    }

    get listaAnos () {
        return this.$store.state.anos;
    }

    get ano () {
        return this.$store.getters.veiculo_ano;
    }

    set ano ( value ) {
        this.$store.dispatch("SET_ANO", value).then();
    }

    get errorAno () {
        return this.$store.state.errors.ano;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }
}
